// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'battery-charge-solid';

export const Component = () => (
  <path d='M22.559 8.927h.479c.43 0 .766.144 1.053.432.288.287.432.622.432 1.053v2.922c0 .43-.144.766-.432 1.053a1.408 1.408 0 0 1-1.053.432h-.48v2.442c0 .431-.143.766-.43 1.054a1.408 1.408 0 0 1-1.055.431H1.485c-.431 0-.766-.144-1.054-.431A1.408 1.408 0 0 1 0 17.26V6.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 1.485 5h19.588c.432 0 .767.144 1.054.431.288.288.432.623.432 1.054v2.442Zm-11.782 3.928L9.77 16.782l3.975-4.933-1.963-.958.958-3.927-3.928 4.885 1.964 1.006Z' />
);

export const viewBox = '0 0 25 25';
